// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"122":"b8d975bb","208":"1582c9a3","252":"3750745a","257":"6dd2356f","406":"67f103be","453":"37edddcc","721":"a0a8c202","910":"7f24270c","975":"8ba70259"}[chunkId] + ".js";
};